

angular.module('theme.core.progressbar', [])

.directive('contextualProgressbar', function() {
  return {
    replace: true,
    transclude: true,
    restrict: 'E',
    scope: {
      value: '=',
      max: '=?',
      type: '@',
      heading: '@',
    },
    templateUrl: 'framework/partials/ui-elements/contextual-progressbar.html',
  };
});